import React, { useState, useEffect } from "react";
import { mainTable } from "../css/Common";
import "react-toastify/dist/ReactToastify.css";
import { inventoryIndentHeaders } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import MainPopup from "../popup-containers/MainPopup";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { Indent } from "../popup-containers/IndentPopup";
import moment from "moment/moment";
import toast, { Toaster } from "react-hot-toast";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import AddScreenTitle from "../components/AddScreenTitle";
import GridPage from "../components/GridPage";
import Buttons from "../components/Buttons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import usePrevious from "../Hook/UsePrevious";
import { useLocation } from "react-router-dom";
import { useUserCapability } from "../components/ConstantReducerProvider";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";

function InventoryIndent() {
  const location = useLocation();
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [bindInventoryIndentsData, setBindInventoryIndentsData] = useState([]);
  const [indentExcelDatas, setIndentExcelDatas] = useState([]);
  const [bindOrganizationStructure, setOrganizationStructure] = useState([]);
  const [bindAreaDD1, setBindAreaDD1] = useState([]);
  const [sdpDD, setSdpDD] = useState([]);
  const [commodityType, setCommodityType] = useState([]);
  const [bindSdpDropDown, setBindSdpDropDown] = useState([]);
  const [bindFilteredSdpDropDown, setBindFilteredSdpDropDown] = useState([]);
  const [bindFieldWorkerName, setBindFieldWorkerName] = useState([]);
  const [bindCBP, setBindCBP] = useState([]);
  const [bindLocationDropDown, setBindLocationDropDown] = useState([]);
  const [bindBranchDropDown, setBindBranchDropDown] = useState([]);
  const [bindAreaDropDown, setBindAreaDropDown] = useState([]);
  const [bindAreaDatas, setBindAreaDatas] = useState([]);
  const [bindCommoditiesCategory, setBindCommoditiesCategory] = useState([]);
  const [bindCommodities, setBindCommodities] = useState([]);

  const [bindIndentChildDatas, setBindIndentChildDatas] = useState([]);
  const [iCParticipantDetails, setICParticipantDetails] = useState("");
  const [bindCategoryNameDropDown, setBindCategoryNameDropDown] = useState([]);
  const [bindCategoryDropDown, setBindCategoryDropDown] = useState([]);
  const [bindCommodityType, setBindCommodityType] = useState([]);
  const [category, setCategory] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [getCategoryNameDropDown, setGetCategoryNameDropDown] = useState([]);
  const [selectedReceivedFromError, setSelectedReceivedFromError] =
    useState("");

  const [indentChildTableError, setIndentChildTableErrorError] = useState("");
  const [txnIndentId, setTxnIndentId] = useState("");
  const [indentNumber, setIndentNumber] = useState("ININD");
  const [indentDate, setIndentDate] = useState("");
  const [indentAreaName, setIndentAreaName] = useState("");
  const [indentAreaNameError, setIndentAreaNameError] = useState("");
  const [indentFrom1, setIndentFrom1] = useState("");
  const [indentFrom2, setIndentFrom2] = useState("");
  const [indentFrom2Error, setIndentFrom2Error] = useState("");
  const [description, setDescription] = useState("");
  const [indentNumberError, setIndentNumberError] = useState("");
  const [sdp, setSdp] = useState("");
  const [branch, setBranch] = useState("");
  const [area, setArea] = useState("");
  const [sdpId, setSdpId] = useState("");
  const [branchId, setBranchId] = useState("");

  const [indentData, setIndentData] = useState({});
  const [currentData2, setCurrentData2] = useState({});
  const [currentData3, setCurrentData3] = useState({});
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [visibleAdd, setVisibleAdd] = React.useState(false);
  const [visibleTable, setVisibleTable] = React.useState(true);
  const [updateButton, setUpdateButton] = React.useState(false);
  const [submitButton, setSubmitButton] = React.useState(true);
  const [editMode, setEditMode] = useState([]);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteButton, setDeleteButton] = useState(false);
  const [blockButton, setBlockButton] = useState(false);
  const [unBlockButton, setUnBlockButton] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [visibleSdp, setVisibleSdp] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [indentFrom1Label, setIndentFrom1Label] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // Indent Table start
  const [tableData, setTableData] = useState([
    {
      indentCategoryType: "",
      indentCategory: "",
      indentName: "",
      indentQuantity: "",
      UOM: "",
      indentCategoryList: [],
      indentNameList: [],
    },
  ]);

  const previousTableData = usePrevious(tableData);

  const headerData = [
    {
      title: "Category Type",
      key: "indentCategoryType",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Category",
      key: "indentCategory",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Name",
      key: "indentName",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Qty.",
      key: "indentQuantity",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "U.O.M.",
      key: "UOM",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Action",
      key: "Action",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
  ];

  const inventoryIndentData = async (userProfileDatas = []) => {
    if (!userProfileDatas.length) return;

    try {
      const [profile] = userProfileDatas;

      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // fallback if null/undefined
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
      };

      const response = await BindPostAPI(
        [data],
        "InventoryIndentAPI/BindInventoryIndent",
      );

      const tableData = response?.data?.Table ?? [];
      const table1Data = response?.data?.Table1 ?? [];

      setBindInventoryIndentsData(tableData);
      setBindIndentChildDatas(table1Data);
    } catch (error) {
      console.error("Error fetching inventory indent data:", error);
      setBindInventoryIndentsData([]);
      setBindIndentChildDatas([]);
    } finally {
      // setIsLoading(false);
    }
  };

  // This function is helping for Popup open .
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };
  // This function is helping for Popup close .
  const handleClose = () => {
    setpopUpOpen(false);
  };

  const showadd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setSubmitButton(true);
    setAddScreenTitle(true);
    setUpdateButton(false);
    setUpdateScreenTitle(false);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setIndentDate(formattedDate);
    getBranch(userProfileDatas);
    indentFrom();
  };
  const cancel = () => {
    setIsLoading(false);
    setIndentData({});
    inventoryIndentData(userProfileDatas);
    setSelectedReceivedFrom("");
    setSelectedReceivedFrom1("");
    setIndentChildTableErrorError("");
    setICParticipantDetails("");
    setIndentAreaNameError("");
    setIndentFrom2Error("");
    setVisibleAdd(false);
    setVisibleTable(true);
    setSubmitButton(false);
    setAddScreenTitle(false);
    setSubmitBtnDisabled(false);
    setSubmitVisibleButton(false);
    setUpdateButton(false);
    setUpdateScreenTitle(false);
    handleOpen(false);
    const reset = {
      indentCategoryType: "",
      indentCategory: "",
      indentName: "",
      indentQuantity: "",
      UOM: "",
    };
    setTableData([reset]);
    setIndentNumber("ININD");
    setIndentDate("");
    setIndentAreaName("");
    setIndentFrom1("");
    setIndentFrom2("");
    setDescription("");
    setBranch("");
    setSdp("");
    setSdpId("");
    setArea("");
    setIndentNumberError("");
    setSelectedReceivedFromError("");
    setIndentChildTableErrorError("");
    setEditMode(false);
    setRowIndex("");
    setSelectedRowIndex("");
    setSelectedReceivedFrom("");
    setTableData([
      {
        indentCategoryType: "",
        indentCategory: "",
        indentName: "",
        indentQuantity: "",
        UOM: "",
      },
    ]);
  };

  const appendDataToState = (newDataString) => {
    const newDataArray = JSON.parse(newDataString);
    //  handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => ({
      indentCategoryType: data.MstCommodityTypeId,
      indentCategory: data.MstCommodityCategoryId,
      indentName: data.MstCommoditiesId,
      indentQuantity: data.IndentQuantity,
      UOM: data.IndentUOM,
    }));

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    convertArrayToJSONString(formattedDataArray);
  };

  const editDropDownValues = () => {
    if (editMode && selectedRowIndex !== null) {
      //handleAreaDropDown(selectedRowIndex);
      handleCategoryReceivedItemDropDown(selectedRowIndex);
    }
  };

  useEffect(editDropDownValues, [editMode, selectedRowIndex]);

  const handleCategoryReceivedItemDropDown = (rowIndex) => {
    const indentData = bindInventoryIndentsData[rowIndex];

    let editCategoryReceivedItemDropDownValue;

    if (indentData.IndentFrom1Id == 3) {
      const SDPValue = bindFilteredSdpDropDown.find(
        (item) => item.value == indentData.IndentFrom2Id,
      );

      editCategoryReceivedItemDropDownValue = {
        value: indentData.IndentFrom2Id,
        label: SDPValue ? SDPValue.label : "Unknown",
      };
    } else if (indentData.IndentFrom1Id === 2) {
      const eindentCategoryReceivedItemValue = bindBranchDropDown.find(
        (item) => item.value == indentData.IndentFrom2Id,
      );
      editCategoryReceivedItemDropDownValue = {
        value: indentData.IndentFrom2Id,
        label: eindentCategoryReceivedItemValue
          ? eindentCategoryReceivedItemValue.label
          : "Unknown",
      };
    } else if (indentData.IndentFrom1Id === 4) {
      const Fieldvalues = bindFieldWorkerName.find(
        (item) => item.value == indentData.IndentFrom2Id,
      );
      editCategoryReceivedItemDropDownValue = {
        value: indentData.IndentFrom2Id,
        label: Fieldvalues ? Fieldvalues.label : "Unknown",
      };
    } else if (indentData.IndentFrom1Id === 5) {
      const Fieldvalues = bindCBP.find(
        (item) => item.value === indentData.IndentFrom2Id,
      );
      editCategoryReceivedItemDropDownValue = {
        value: indentData.IndentFrom2Id,
        label: Fieldvalues ? Fieldvalues.label : "Unknown",
      };
    }
    setIndentFrom2(editCategoryReceivedItemDropDownValue);
  };

  const handleEdit = async (rowIndex) => {
    getBranch(userProfileDatas);
    indentFrom();
    setEditMode(true);
    setSelectedRowIndex(rowIndex);

    setSubmitButton(false);
    setUpdateButton(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    const bindIndentId = bindInventoryIndentsData[rowIndex].TxnIndentId;
    setIndentNumber(bindInventoryIndentsData[rowIndex].IndentNo);
    setIndentAreaName(bindInventoryIndentsData[rowIndex].MstAreaId);
    setIndentDate(
      moment(bindInventoryIndentsData[rowIndex].IndentDate).format(
        "YYYY-MM-DD",
      ),
    );

    setSdp(
      visibleSdp
        ? bindInventoryIndentsData[rowIndex].SDP_en
        : bindInventoryIndentsData[rowIndex].MstSdpId,
    );
    setSdpId(bindInventoryIndentsData[rowIndex].MstSdpId);
    setBranch(bindInventoryIndentsData[rowIndex].LocationName_en);
    setBranchId(bindInventoryIndentsData[rowIndex].MstBranchId);
    setDescription(bindInventoryIndentsData[rowIndex].Remarks_en);
    setTxnIndentId(bindInventoryIndentsData[rowIndex].TxnIndentId);
    // setIndentData(bindInventoryIndentsData[rowIndex]);
    setArea(bindInventoryIndentsData[rowIndex].ReceivedMstAreaId);
    setIndentFrom1(bindInventoryIndentsData[rowIndex].IndentFrom1Id);
    const IndentF = bindInventoryIndentsData[rowIndex].IndentFrom1Id;
    if (IndentF == 1) {
      setSelectedReceivedFrom1(null);
      setSelectedReceivedFrom(IndentF);
    } else if (IndentF == 2) {
      setSelectedReceivedFrom(IndentF);
      setSelectedReceivedFrom1("2");
    } else if (IndentF == 3) {
      setSelectedReceivedFrom(IndentF);
      setSelectedReceivedFrom1("3");
    } else if (IndentF == 4) {
      setSelectedReceivedFrom(IndentF);
      setSelectedReceivedFrom1("4");
    } else if (IndentF == 5) {
      setSelectedReceivedFrom(IndentF);
      setSelectedReceivedFrom1("5");
    }
    setIndentFrom2(bindInventoryIndentsData[rowIndex].IndentFrom2Id);
    const ParticipantDetailDatas = Object.values(bindIndentChildDatas).filter(
      (item) => {
        return String(item.TxnIndentId) === String(bindIndentId);
      },
    );
    if (ParticipantDetailDatas.length === 0) {
      setTableData([
        {
          indentCategoryType: "",
          indentCategory: "",
          indentName: "",
          indentQuantity: "",
          UOM: "",
          indentCategoryList: [],
          indentNameList: [],
        },
      ]);
    } else {
      // Append the filtered data to your state using appendDataToState function
      appendDataToState(JSON.stringify(ParticipantDetailDatas));
    }
    // appendDataToState(JSON.stringify(ParticipantDetailDatas));
  };

  const handleReceivedFromChange = (e) => {
    setSelectedReceivedFrom(e.target.value);
    setSelectedReceivedFrom1(e.target.value);
    setIndentFrom1(e.target.value);
    setIndentFrom2Error("");
    setIndentFrom2("");
    setIndentAreaName("");
    setIndentAreaNameError("");
  };
  const indentFrom = () => {
    if (indentFrom1) {
      const organizationStructureDataDropDown = bindOrganizationStructure.find(
        (item) => item.value == indentFrom1,
      );

      const testOrgani = {
        value: indentFrom1,
        label: organizationStructureDataDropDown
          ? organizationStructureDataDropDown.label
          : "Unknown",
      };
      setIndentFrom1Label(testOrgani.label);
    }
  };
  useEffect(() => {
    if (addScreenTitle || updateScreenTitle) {
      indentFrom();
    }
  }, [indentFrom1]);

  const [selectedReceivedFrom, setSelectedReceivedFrom] = useState(null);
  const [selectedReceivedFrom1, setSelectedReceivedFrom1] = useState(null);

  const [bindSupplier, setBindSupplier] = useState([]);
  const [bindPartnerOrganization, setBindPartnerOrganization] = useState([]);
  const getDataBasedOnReceivedFrom = () => {
    if (selectedReceivedFrom1 === 1) {
      setSelectedReceivedFrom1(null);
    } else if (selectedReceivedFrom1 === "2") {
      return bindBranchDropDown;
    } else if (selectedReceivedFrom1 === "3") {
      return bindSupplier;
    } else if (selectedReceivedFrom1 === "4") {
      return bindFilteredSdpDropDown;
    } else if (selectedReceivedFrom1 === "5") {
      return bindFieldWorkerName;
    } else if (selectedReceivedFrom1 === "6") {
      return bindPartnerOrganization;
    }
    // Default to an empty array or any other default data source.
    return [];
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        await Promise.all([
          indentDropDownDatas(),
          loadCategory(),
          loadCategoryName(),
          inventoryIndentData(userProfileDatas),
        ]);
        setIsLoading(false);
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };

    fetchData();
    ReceiptDropDownDatas();
  }, []);

  const ReceiptDropDownDatas = async () => {
    try {
      const [supplierResponse, orsNameResponse, receivedFromResponse] =
        await Promise.all([
          BindAPI("SupplierAPI/BindSupplier"),
          BindAPI("InventoryReceiptAPI/BindORSName"),
          BindAPI("InventoryReceiptAPI/BindInventoryReceivedFrom"),
        ]);

      const safe = (res) => res?.data?.Table ?? [];
      const safe2 = (res) => res?.data?.Table2 ?? [];
      const safe3 = (res) => res?.data?.Table3 ?? [];
      const safe4 = (res) => res?.data?.Table4 ?? [];
      const safe5 = (res) => res?.data?.Table5 ?? [];
      const safe6 = (res) => res?.data?.Table6 ?? [];
      const safe7 = (res) => res?.data?.Table7 ?? [];
      const safe8 = (res) => res?.data?.Table8 ?? [];
      const safe9 = (res) => res?.data?.Table9 ?? [];

      setBindSupplier(
        safe(supplierResponse).map((item) => ({
          value: item.MstSupplierId,
          label: item.SupplierName,
        })),
      );

      const [profile] = userProfileDatas;

      const filteredData = profile?.MstLocationId
        ? safe2(orsNameResponse).filter(
            (item) => item.MstLocationId === profile.MstLocationId,
          )
        : safe2(orsNameResponse);

      setBindPartnerOrganization(
        filteredData.map((item) => ({
          value: item.MstPartnerOrganizationId,
          label: item.PartnerOrganizationName,
        })),
      );

      // HANDLE RECEIVED-FROM DROPDOWN SAFELY
      const received = safe(receivedFromResponse);

      let filteredReceived = received;

      if (userProfileDatas[0]?.MstRoleId == 7) {
        filteredReceived = received.filter(
          (item) =>
            item.BlockedBy == null &&
            ![1, 3, 5, 6].includes(item.TxnReceivedFromId),
        );
      } else if (
        userProfileDatas[0]?.MstOrganizationId == 3 &&
        userProfileDatas[0]?.MstRoleId != 7
      ) {
        filteredReceived = received.filter(
          (item) => item.BlockedBy == null && item.TxnReceivedFromId !== 1,
        );
      } else {
        filteredReceived = received.filter((item) => item.BlockedBy == null);
      }
    } catch (error) {
      console.error("Error fetching receipt dropdown data:", error);
    }
  };

  const indentDropDownDatas = async () => {
    try {
      // Run independent API calls in parallel
      const [
        locationResponse,
        sdpResponse,
        areaResponse,
        receivedFromResponse,
        categoryResponse,
        commodityTypeResponse,
        nameResponse,
        orsNameResponse,
        cbpNameResponse,
      ] = await Promise.all([
        BindAPI("LocationAPI/GetLocation"),
        BindAPI("SDPAPI/GetSDP"),
        BindAPI("AreaAPI/GetArea"),
        BindAPI("InventoryReceiptAPI/BindInventoryReceivedFrom"),
        BindAPI("CommoditiesAPI/GetCommoditiesCategory"),
        BindAPI("InventoryReceiptAPI/BindCommodityType"),
        BindAPI("CommoditiesAPI/BindCommodities"),
        BindAPI("InventoryReceiptAPI/BindORSName"),
        BindAPI("CBPAPI/BindCBP"),
      ]);

      // Safely extract tables
      const locationTable = locationResponse?.data?.Table ?? [];
      const sdpTable = sdpResponse?.data?.Table ?? [];
      const areaTable = areaResponse?.data?.Table ?? [];
      const receivedFromTable = receivedFromResponse?.data?.Table ?? [];
      const categoryTable = categoryResponse?.data?.Table ?? [];
      const commodityTypeTable = commodityTypeResponse?.data?.Table ?? [];
      const nameTable = nameResponse?.data?.Table ?? [];
      const orsTable = orsNameResponse?.data?.Table ?? [];
      const cbpTable = cbpNameResponse?.data?.Table ?? [];

      // FIXED: let instead of const
      let receivedFromData = [];

      if (userProfileDatas[0]?.MstOrganizationId == 1) {
        receivedFromData = receivedFromTable
          .filter((item) => [2, 3, 4, 5, 6, 7].includes(item.TxnReceivedFromId))
          .map((item) => ({
            value: item.TxnReceivedFromId,
            label: item.ReceivedFrom_en,
          }));
      } else if (userProfileDatas[0]?.MstOrganizationId == 2) {
        receivedFromData = receivedFromTable
          .filter((item) => [1, 2, 3, 6, 7].includes(item.TxnReceivedFromId))
          .map((item) => ({
            value: item.TxnReceivedFromId,
            label: item.ReceivedFrom_en,
          }));
      } else if (userProfileDatas[0]?.MstOrganizationId == 3) {
        receivedFromData = receivedFromTable
          .filter((item) => [2, 4].includes(item.TxnReceivedFromId))
          .map((item) => ({
            value: item.TxnReceivedFromId,
            label: item.ReceivedFrom_en,
          }));
      } else if (userProfileDatas[0]?.MstRoleId == 7) {
        receivedFromData = receivedFromTable
          .filter((item) => [2, 4].includes(item.TxnReceivedFromId))
          .map((item) => ({
            value: item.TxnReceivedFromId,
            label: item.ReceivedFrom_en,
          }));
      }

      const areaData = areaTable.map((item) => ({
        value: item.MstAreaId,
        label: item.AreaName_en,
      }));

      const locationData = locationTable.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      const sdpData = sdpTable.map((item) => ({
        value: item.MstSDPId,
        label: item.SDP_en,
      }));

      const categoryData = categoryTable.map((item) => ({
        value: item.MstCommodityCategoryId,
        label: item.CommodityCategory_en,
      }));

      const nameData = nameTable.map((item) => ({
        value: item.MstCommoditiesId,
        label: item.CommodityName_en,
      }));

      const commodityTypeData = commodityTypeTable.map((item) => ({
        value: item.MstCommodityTypeId,
        label: item.CommodityType_en,
      }));
      var orsNameData = [];
      if (userProfileDatas[0]?.MstOrganizationId == 1) {
        orsNameData = orsTable.map((item) => ({
          value: item.MstUserId,
          label: item.FirstName_en,
        }));
      } else {
        orsNameData = orsTable
          .filter(
            (item) =>
              item.MstOrganizationId == userProfileDatas[0]?.MstLocationId,
          )
          .map((item) => ({
            value: item.MstUserId,
            label: item.FirstName_en,
          }));
      }
      const cbpNameData = cbpTable.map((item) => ({
        value: item.MstCBPId,
        label: item.CBPName,
      }));

      // Set states
      setBindAreaDatas(areaTable);
      setBindAreaDropDown(areaData);
      setBindCommoditiesCategory(categoryTable);
      setBindCommodities(nameTable);
      setOrganizationStructure(receivedFromData);
      setBindLocationDropDown(locationTable);
      setBindSdpDropDown(sdpTable);
      setBindCategoryDropDown(categoryData);
      setBindCategoryNameDropDown(nameData);
      setBindFieldWorkerName(orsNameData);
      setBindCBP(cbpNameData);
      setBindCommodityType(commodityTypeData);
    } catch (error) {
      console.error("Error in indentDropDownDatas:", error);

      // Reset states
      setBindAreaDatas([]);
      setBindAreaDropDown([]);
      setBindCommoditiesCategory([]);
      setBindCommodities([]);
      setOrganizationStructure([]);
      setBindLocationDropDown([]);
      setBindSdpDropDown([]);
      setBindCategoryDropDown([]);
      setBindCategoryNameDropDown([]);
      setBindFieldWorkerName([]);
      setBindCBP([]);
      setBindCommodityType([]);
    }
  };

  const handleSdpDropdownChange = (e) => {
    setSdp(e.target.value);
  };

  useEffect(() => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const currentTableData = [...tableData];
      currentTableData.forEach((row, index) => {
        if (row?.indentCategoryType) {
          const getFilteredCategory = bindCommoditiesCategory
            .filter((item) => item.MstCommodityTypeId == row.indentCategoryType)
            .map((items) => ({
              value: items.MstCommodityCategoryId,
              label: items.CommodityCategory_en,
            }));
          row.indentCategoryList = getFilteredCategory;
        }
        if (row?.indentCategory) {
          const selectedCommoditiesCategory = bindCommodities
            .filter((item) => item.MstCommodityCategoryId == row.indentCategory)
            .map((item) => ({
              value: item.MstCommoditiesId,
              label: item.CommodityName_en,
              uom: item.CommodityUOM,
            }));
          row.indentNameList = selectedCommoditiesCategory;
          // Check if there's a selected commodity for the current row
          const selectedCommodity = selectedCommoditiesCategory.find(
            (item) => item.value === row.indentName,
          );
          // If a selected commodity is found, set the unitOfMeasure for the row
          if (selectedCommodity) {
            row.UOM = selectedCommodity.uom;
          } else {
            row.UOM = ""; // Reset if no selected commodity
          }
        }
      });
      setTableData(currentTableData);
    }
    // Iterate through all rows in tableData
  }, [tableData]);

  const validate = (flag) => {
    const errors = {};
    if (flag === 1 || flag === 2) {
      if (!selectedReceivedFrom) {
        errors.selectedReceivedFrom = "Select Indent";
      }
      if (!indentAreaName && selectedReceivedFrom1 === "4") {
        errors.indentAreaName = "Select Area Name";
      }
      if (!indentFrom2) {
        errors.indentFrom2 =
          selectedReceivedFrom1 === "2"
            ? "Select Indent Branch/Project"
            : selectedReceivedFrom1 === "4"
              ? "Select Indent S.D.P"
              : selectedReceivedFrom1 === "5"
                ? "Select Indent Outreach Staff"
                : "Please select a valid option";
      }
    }
    setSelectedReceivedFromError(errors.selectedReceivedFrom || "");
    setIndentAreaNameError(errors.indentAreaName || "");
    setIndentFrom2Error(errors.indentFrom2 || "");

    return errors;
  };
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    const createdBy = sessionStorage.getItem("createdBy");
    if (flag == 1 || flag == 2) {
      // validation start
      const inventoryIndentValidation = validate(flag);
      if (Object.keys(inventoryIndentValidation).length !== 0) {
        setIsOpen(true);
      }
      if (iCParticipantDetails.trim() === "") {
        setIndentChildTableErrorError("Fill the above table");
        setSubmitBtnDisabled(false);
        setIsOpen(true);
        return; // Stop further execution
      }
      if (Object.keys(inventoryIndentValidation).length === 0) {
        setSubmitBtnDisabled(true);
        setIsLoading(true);
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
      let indentData;
      try {
        indentData = JSON.parse(iCParticipantDetails);
      } catch (error) {
        console.error("Error parsing indent data:", error);
        setIndentChildTableErrorError("Error parsing indent data");
        return; // Stop further execution
      }

      if (!Array.isArray(indentData)) {
        console.error("Indent data is not an array");
        setIndentChildTableErrorError("Indent data is not an array");
        return; // Stop further execution
      }

      const indentErrors = indentData.map((indent, index) => {
        if (!indent) return `Indent at row ${index + 1} is missing.`;
        if (!indent.indentCategoryType)
          return `Indent at row ${index + 1} is missing Commodities.`;
        if (!indent.indentCategory)
          return `Indent at row ${index + 1} is missing Category.`;
        if (!indent.indentName)
          return `Indent at row ${index + 1} is missing Name.`;
        if (!indent.indentQuantity)
          return `Indent at row ${index + 1} is missing Quantity.`;
        if (!indent.UOM)
          return `Indent at row ${index + 1} is missing Unit Of Measure.`;
        return null;
      });

      const filteredIndentErrors = indentErrors.filter(
        (error) => error !== null,
      );
      let inventoryIndentChildValidation;
      if (filteredIndentErrors.length > 0) {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
        inventoryIndentChildValidation = 1;
        setIndentChildTableErrorError(filteredIndentErrors.join("; "));
      } else {
        setIndentChildTableErrorError(""); // No errors found
        inventoryIndentChildValidation = 0;
      }

      if (
        Object.keys(inventoryIndentValidation).length === 0 &&
        inventoryIndentChildValidation == 0
      ) {
        setSubmitBtnDisabled(true);
        setIsLoading(true);
        const languageKeys = [
          "ta", // Tamil
          "hi", // Hindi
          "mr", // Marathi
          "gu", // Gujarati
          "kn", // Kannada
          "ml", // Malayalam
          "te", // Telugu
          "bn", // Bengali
          "or", // Oriya
        ];

        const translatedIndentFrom1Label = []; // Create an array to store translations

        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(
            indentFrom1Label,
            i,
          );
          translatedIndentFrom1Label.push(
            translateText.data.data.translations[0].translatedText,
          );
        }

        const translatedIndentFrom2Label = []; // Create an array to store translations

        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(
            indentFrom2.label,
            i,
          );
          translatedIndentFrom2Label.push(
            translateText.data.data.translations[0].translatedText,
          );
        }

        const translatedAreaNameLabel = []; // Create an array to store translations

        if (indentAreaName && indentAreaName.label) {
          for (let i of languageKeys) {
            const translateText = await LanguageTranslatorAPI(
              indentAreaName.label,
              i,
            );
            translatedAreaNameLabel.push(
              translateText.data.data.translations[0].translatedText,
            );
          }
        }

        const translatedDescription = []; // Create an array to store translations

        if (description) {
          for (let i of languageKeys) {
            const translateText = await LanguageTranslatorAPI(description, i);
            translatedDescription.push(
              translateText.data.data.translations[0].translatedText,
            );
          }
        }
        const ResultRecipts = flag == 1 ? indentFrom1 : selectedReceivedFrom;
        const data = {
          txnIndentId: txnIndentId ? txnIndentId : 0,
          indentNo: indentNumber,
          indentDate: indentDate,
          mstBranchId: branchId,
          mstSdpId: visibleSdp ? sdpId : sdp,
          receivedMstAreaId: area?.value ? area.value : area || null,
          indentFrom1Id: ResultRecipts,
          indentFrom2Id: indentFrom2.value
            ? indentFrom2.value
            : selectedReceivedFrom1,
          indentAreaNameId: indentAreaName?.value,

          indentFrom1_en: indentFrom1Label,
          indentFrom1_ta: translatedIndentFrom1Label[0],
          indentFrom1_hi: translatedIndentFrom1Label[1],
          indentFrom1_mr: translatedIndentFrom1Label[2],
          indentFrom1_gu: translatedIndentFrom1Label[3],
          indentFrom1_ml: translatedIndentFrom1Label[4],
          indentFrom1_te: translatedIndentFrom1Label[5],
          indentFrom1_kn: translatedIndentFrom1Label[6],
          indentFrom1_bn: translatedIndentFrom1Label[7],
          indentFrom1_or: translatedIndentFrom1Label[8],

          indentFrom2_en: indentFrom2.label,
          indentFrom2_ta: translatedIndentFrom2Label[0],
          indentFrom2_hi: translatedIndentFrom2Label[1],
          indentFrom2_mr: translatedIndentFrom2Label[2],
          indentFrom2_gu: translatedIndentFrom2Label[3],
          indentFrom2_ml: translatedIndentFrom2Label[4],
          indentFrom2_te: translatedIndentFrom2Label[5],
          indentFrom2_kn: translatedIndentFrom2Label[6],
          indentFrom2_bn: translatedIndentFrom2Label[7],
          indentFrom2_or: translatedIndentFrom2Label[8],

          areaName_en: indentAreaName?.label,
          areaName_ta: translatedAreaNameLabel[0],
          areaName_hi: translatedAreaNameLabel[1],
          areaName_mr: translatedAreaNameLabel[2],
          areaName_gu: translatedAreaNameLabel[3],
          areaName_ml: translatedAreaNameLabel[4],
          areaName_te: translatedAreaNameLabel[5],
          areaName_kn: translatedAreaNameLabel[6],
          areaName_bn: translatedAreaNameLabel[7],
          areaName_or: translatedAreaNameLabel[8],

          indentDetails: iCParticipantDetails,

          remarks_en: description,
          remarks_ta: translatedDescription[0],
          remarks_hi: translatedDescription[1],
          remarks_mr: translatedDescription[2],
          remarks_gu: translatedDescription[3],
          remarks_kn: translatedDescription[4],
          remarks_ml: translatedDescription[5],
          remarks_te: translatedDescription[6],
          remarks_bn: translatedDescription[7],
          remarks_or: translatedDescription[8],
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(
          [data],
          "InventoryIndentAPI/IUDInventoryIndent",
        );
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Inventory Indent added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setIndentNumber(response.data.Table1[0].IndentNo);
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Inventory Indent data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Inventory Indent updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Inventory Indent data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      }
    } else {
      setIsLoading(true);
      const data = {
        txnIndentId: bindInventoryIndentsData[items].TxnIndentId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI(
        [data],
        "InventoryIndentAPI/IUDInventoryIndent",
      );
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Inventory Indent data deleted successfully 🗑️",
            1000,
            cancel(),
          );
          cancel();
        } else {
          toast.error("Failed to delete Inventory Indent data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            " Inventory Indent data blocked successfully 🚫",
            1000,
            cancel(),
          );
          cancel();
        } else {
          toast.error("Failed to block Inventory Indent data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Inventory Indent data unblocked successfully ✅",
            1000,
            cancel(),
          );
          cancel();
        } else {
          toast.error("Failed to unblock Inventory Indent data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };

  const HandleUserDetails = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteButton(false);
      setBlockButton(false);
      setUnBlockButton(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteButton(true);
      setBlockButton(false);
      setUnBlockButton(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteButton(false);
      setBlockButton(true);
      setRowIndex(rowIndex);
      setUnBlockButton(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteButton(false);
      setBlockButton(false);
      setRowIndex(rowIndex);
      setUnBlockButton(true);
    }
    setIndentData(bindInventoryIndentsData[rowIndex]);

    var DateOpeningPart = bindInventoryIndentsData[rowIndex].IndentDate;
    const OpeningdatePart = DateOpeningPart.split("T")[0];
    setIndentDate(OpeningdatePart);

    const ParticipantDetailDatas = Object.values(bindIndentChildDatas).filter(
      (item) =>
        item.TxnIndentId === bindInventoryIndentsData[rowIndex].TxnIndentId,
    );

    setCurrentData2(ParticipantDetailDatas);

    const drpdetailsData = [
      OpeningdatePart,
      bindCommoditiesCategory,
      bindCommodities,
    ];
    setCurrentData3(drpdetailsData);
  };

  const handleDeleteRow = (index) => {
    setTableData((prevData) => {
      const updatedTableData = prevData.filter((_, i) => i !== index);

      // Ensure at least one row exists
      if (updatedTableData.length === 0) {
        const newRow = {
          indentCategoryType: "",
          indentCategory: "",
          indentName: "",
          indentQuantity: "",
          UOM: "",
          indentCategoryList: "",
          indentNameList: "",
        };
        updatedTableData.push(newRow); // Add a default row if the table is empty
      }

      convertArrayToJSONString(updatedTableData); // Call convertArrayToJSONString
      return updatedTableData;
    });
  };

  const handleAddRow = () => {
    const newRow = { ...tableData[tableData.length - 1] }; // Copy the last row
    newRow.indentCategoryType = "";
    newRow.indentCategory = ""; // Clear the values of the new row
    newRow.indentName = "";
    newRow.indentQuantity = "";
    newRow.UOM = "";
    newRow.indentCategoryList = [];
    newRow.indentNameList = [];

    setTableData((prevData) => [...prevData, newRow]); // Add the new row to the table data
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setICParticipantDetails(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const handleInputChange = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevData) => {
      const updatedData = [...prevData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const fetchData = async (endpoint, setter) => {
    try {
      const response = await BindAPI(endpoint);
      setter(response?.data?.Table || []);
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
    }
  };

  // Usage
  const loadCategory = () =>
    fetchData("InventoryIndentAPI/BindCategory", setCategory);
  const loadCategoryName = () =>
    fetchData("InventoryIndentAPI/BindCategoryName", setCategoryName);

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const areaSelectedValue = bindAreaDatas.find(
      (item) => item.MstSDPId == indentFrom2.value, // Replace with the desired MstStateId
    );

    if (areaSelectedValue) {
      const areaLabels = bindAreaDatas
        .filter((item) => item.MstSDPId === areaSelectedValue.MstSDPId)
        .map((item) => ({
          MstAreaId: item.MstAreaId,
          AreaName_en: item.AreaName_en,
        }));

      const areaSelected = areaLabels.map((AR) => ({
        value: AR.MstAreaId, // Replace with the appropriate value
        label: AR.AreaName_en,
      }));

      setBindAreaDropDown(areaSelected);
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [indentFrom2.value]);

  useEffect(() => {
    if (!userProfileDatas || userProfileDatas.length === 0) return; // guard

    const branchSelectedValue = bindLocationDropDown.find(
      (item) => item.MstLocationId === userProfileDatas[0]?.MstLocationId,
    );

    if (branchSelectedValue) {
      const branchLabels = bindLocationDropDown
        .filter(
          (item) => item.MstLocationId === branchSelectedValue.MstLocationId,
        )
        .map((item) => ({
          MstLocationId: item.MstLocationId,
          LocationName_en: item.LocationName_en,
        }));
      if (userProfileDatas[0]?.MstOrganizationId != 2) {
        const branchSelected = branchLabels.map((item) => ({
          value: item.MstLocationId,
          label: item.LocationName_en,
        }));

        setBindBranchDropDown(branchSelected);
      } else {
        const branchLabels = bindLocationDropDown.map((item) => ({
          value: item.MstLocationId,
          label: item.LocationName_en,
        }));
        setBindBranchDropDown(branchLabels);
      }
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [userProfileDatas?.[0]?.MstLocationId, bindLocationDropDown]);
  useEffect(() => {
    if (!userProfileDatas || userProfileDatas.length === 0) return; // guard

    const branchSelectedValue = bindSdpDropDown.find(
      (item) => item.MstLocationId == userProfileDatas[0]?.MstLocationId,
    );

    if (branchSelectedValue) {
      const branchLabels = bindSdpDropDown
        .filter(
          (item) => item.MstLocationId === branchSelectedValue.MstLocationId,
        )
        .map((item) => ({
          MstSDPId: item.MstSDPId,
          SDP_en: item.SDP_en,
        }));
      if (userProfileDatas[0]?.MstOrganizationId != 2) {
        const branchSelected = branchLabels.map((item) => ({
          value: item.MstSDPId,
          label: item.SDP_en,
        }));

        setBindFilteredSdpDropDown(branchSelected);
      } else {
        const branchLabels = bindSdpDropDown.map((item) => ({
          value: item.MstSDPId,
          label: item.SDP_en,
        }));
        setBindFilteredSdpDropDown(branchLabels);
      }
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [userProfileDatas?.[0]?.MstLocationId, bindSdpDropDown]);

  useEffect(() => {
    if (location.pathname == "/inventoryindent") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
      inventoryIndentData(userProfileDatas);
    }
  }, [location, userProfileDatas]);

  const getBranch = (userProfileDatas) => {
    if (Array.isArray(userProfileDatas) && userProfileDatas.length > 0) {
      setBranch(userProfileDatas[0].LocationName_en);
      setBranchId(userProfileDatas[0].MstLocationId);
      if (userProfileDatas.length === 1) {
        setVisibleSdp(true);
        // If userProfileDatas has only one element
        setBranch(userProfileDatas[0].LocationName_en);
        setBranchId(userProfileDatas[0].MstLocationId);
        setSdp(userProfileDatas[0].SDP_en);
        setSdpId(userProfileDatas[0].MstSDPId);
      } else {
        const newSdp = userProfileDatas.map((userProfile) => ({
          value: userProfile.MstSDPId,
          label: userProfile.SDP_en,
        }));
        setSdpDD(newSdp);
      }
    } else {
      // handle else case if needed
    }
  };
  useEffect(() => {
    if (addScreenTitle || updateScreenTitle) {
      getBranch(userProfileDatas);
    }
  }, []);
  useEffect(() => {
    // Find the selected state in getLocationDatas
    if (visibleSdp) {
      const areaSelectedValue = bindAreaDatas.find(
        (item) => item.MstSDPId == parseInt(sdpId), // Replace with the desired MstStateId
      );

      if (areaSelectedValue) {
        const areaLabels = bindAreaDatas
          .filter((item) => item.MstSDPId === areaSelectedValue.MstSDPId)
          .map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

        const areaSelected = areaLabels.map((AR) => ({
          value: AR.MstAreaId, // Replace with the appropriate value
          label: AR.AreaName_en,
        }));

        setBindAreaDD1(areaSelected);
      } else {
        console.log("stateSelectedValue is undefined or not found.");
      }
    } else {
      const areaSelectedValue = bindAreaDatas.find(
        (item) => item.MstSDPId == sdp, // Replace with the desired MstStateId
      );

      if (areaSelectedValue) {
        const areaLabels = bindAreaDatas
          .filter((item) => item.MstSDPId === areaSelectedValue.MstSDPId)
          .map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

        const areaSelected = areaLabels.map((AR) => ({
          value: AR.MstAreaId, // Replace with the appropriate value
          label: AR.AreaName_en,
        }));

        setBindAreaDD1(areaSelected);
      } else {
        console.log("stateSelectedValue is undefined or not found.");
      }
    }
  }, [parseInt(sdpId) ? parseInt(sdpId) : null, sdp ? sdp : null]);

  const inventoryIndentExcelHeader = [
    { title: "S.No" },
    { title: "Indent Id" },
    { title: "Indent No." },
    { title: "Indent Date" },

    { title: "Branch" },

    // SDP
    { title: "SDP" },

    // Area
    { title: "Area" },

    { title: "Indent" },
    {
      title: "Indent By",
    },

    { title: "CommodityType_en" },
    { title: "CommodityType_ta" },
    { title: "CommodityType_hi" },
    { title: "CommodityType_mr" },
    { title: "CommodityType_gu" },
    { title: "CommodityType_kn" },
    { title: "CommodityType_ml" },
    { title: "CommodityType_te" },
    { title: "CommodityType_bn" },
    { title: "CommodityType_or" },

    { title: "CommodityCategory_en" },
    { title: "CommodityCategory_ta" },
    { title: "CommodityCategory_hi" },
    { title: "CommodityCategory_mr" },
    { title: "CommodityCategory_gu" },
    { title: "CommodityCategory_kn" },
    { title: "CommodityCategory_ml" },
    { title: "CommodityCategory_te" },
    { title: "CommodityCategory_bn" },
    { title: "CommodityCategory_or" },

    { title: "CommodityName_en" },
    { title: "CommodityName_ta" },
    { title: "CommodityName_hi" },
    { title: "CommodityName_mr" },
    { title: "CommodityName_gu" },
    { title: "CommodityName_kn" },
    { title: "CommodityName_ml" },
    { title: "CommodityName_te" },
    { title: "CommodityName_bn" },
    { title: "CommodityName_or" },

    { title: "Qty." },
    { title: "U.O.M." },

    { title: "Remarks_en" },
    { title: "Remarks_ta" },
    { title: "Remarks_hi" },
    { title: "Remarks_mr" },
    { title: "Remarks_gu" },
    { title: "Remarks_kn" },
    { title: "Remarks_ml" },
    { title: "Remarks_te" },
    { title: "Remarks_bn" },
    { title: "Remarks_or" },

    { title: "Created By" },
  ];
  const createdBy = sessionStorage.getItem("createdBy");
  const handleInventoryIndentExport = async () => {
    debugger;

    try {
      const [profile] = userProfileDatas;

      const payload = {
        MstOrganizationStructureId: profile.MstOrganizationId,
        MstBranchId: profile.MstLocationId,
        MstSdpId: profile.MstSDPId ?? 0,
        MstUserId: profile.MstUserId,
        MstRoleId: profile.MstRoleId,
      };
      const response = await BindPostAPI(
        payload,
        "InventoryIndentAPI/ExcelExportInventoryIdent",
      );

      const rows = response?.data?.Table || [];
      setIndentExcelDatas(response?.data?.Table || []);

      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "INVENTORY INDENT",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "txn_inventoryindent",
            description: "No data available to export",
          },
          "Log/IUDLog",
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "INVENTORY INDENT",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "txn_inventoryindent",
            description: `Inventory Indent Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
      }

      exportInventoryIndentExcel(
        inventoryIndentExcelHeader.map((column) => column.title),
        rows,
      );
    } catch (error) {
      console.error("Inventory Indent Excel Export Error:", error);
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "INVENTORY INDENT",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "txn_inventoryindent",
          description: "Failed to export inventory indent data",
        },
        "Log/IUDLog",
      );

      toast.error("Failed to export inventory Indent data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };

  const exportInventoryIndentExcel = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Inventory Indent",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column, // ✅ STRING ONLY
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: baseStyle }, // S.No
        { v: rowData.TxnIndentId || "-", s: baseStyle },
        { v: rowData.IndentNo || "-", s: baseStyle },
        { v: rowData.IndentDate || "-", s: baseStyle },
        { v: rowData.LocationName_en || "-", s: baseStyle },
        { v: rowData.SDP_en || "-", s: baseStyle },
        { v: rowData.AreaName_en || "-", s: baseStyle },
        { v: rowData.IndentFrom1 || "-", s: baseStyle },
        { v: rowData.FromName_en || "-", s: baseStyle },

        // CommodityType
        { v: rowData.CommodityType_en || "-", s: baseStyle },
        { v: rowData.CommodityType_ta || "-", s: baseStyle },
        { v: rowData.CommodityType_hi || "-", s: baseStyle },
        { v: rowData.CommodityType_mr || "-", s: baseStyle },
        { v: rowData.CommodityType_gu || "-", s: baseStyle },
        { v: rowData.CommodityType_kn || "-", s: baseStyle },
        { v: rowData.CommodityType_ml || "-", s: baseStyle },
        { v: rowData.CommodityType_te || "-", s: baseStyle },
        { v: rowData.CommodityType_bn || "-", s: baseStyle },
        { v: rowData.CommodityType_or || "-", s: baseStyle },

        // CommodityCategory
        { v: rowData.CommodityCategory_en || "-", s: baseStyle },
        { v: rowData.CommodityCategory_ta || "-", s: baseStyle },
        { v: rowData.CommodityCategory_hi || "-", s: baseStyle },
        { v: rowData.CommodityCategory_mr || "-", s: baseStyle },
        { v: rowData.CommodityCategory_gu || "-", s: baseStyle },
        { v: rowData.CommodityCategory_kn || "-", s: baseStyle },
        { v: rowData.CommodityCategory_ml || "-", s: baseStyle },
        { v: rowData.CommodityCategory_te || "-", s: baseStyle },
        { v: rowData.CommodityCategory_bn || "-", s: baseStyle },
        { v: rowData.CommodityCategory_or || "-", s: baseStyle },

        // CommodityName
        { v: rowData.CommodityName_en || "-", s: baseStyle },
        { v: rowData.CommodityName_ta || "-", s: baseStyle },
        { v: rowData.CommodityName_hi || "-", s: baseStyle },
        { v: rowData.CommodityName_mr || "-", s: baseStyle },
        { v: rowData.CommodityName_gu || "-", s: baseStyle },
        { v: rowData.CommodityName_kn || "-", s: baseStyle },
        { v: rowData.CommodityName_ml || "-", s: baseStyle },
        { v: rowData.CommodityName_te || "-", s: baseStyle },
        { v: rowData.CommodityName_bn || "-", s: baseStyle },
        { v: rowData.CommodityName_or || "-", s: baseStyle },

        { v: rowData.IndentQuantity || "-", s: baseStyle },
        { v: rowData.IndentUOM || "-", s: baseStyle },

        // ReceiptReceivedBy Again
        { v: rowData.Remarks_en || "-", s: baseStyle },
        { v: rowData.Remarks_ta || "-", s: baseStyle },
        { v: rowData.Remarks_hi || "-", s: baseStyle },
        { v: rowData.Remarks_mr || "-", s: baseStyle },
        { v: rowData.Remarks_gu || "-", s: baseStyle },
        { v: rowData.Remarks_kn || "-", s: baseStyle },
        { v: rowData.Remarks_ml || "-", s: baseStyle },
        { v: rowData.Remarks_te || "-", s: baseStyle },
        { v: rowData.Remarks_bn || "-", s: baseStyle },
        { v: rowData.remarks_or || "-", s: baseStyle },

        { v: rowData.FullName_en || "-", s: baseStyle },
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 5 }, // S.No
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];

    /* ================= ROW HEIGHTS ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SDP Master");
    XLSX.writeFile(wb, "Inventory Indent.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Inventory Indent"
          header={inventoryIndentHeaders}
          records={bindInventoryIndentsData}
          handleEdit={handleEdit}
          handleAction={HandleUserDetails}
          showAdd={showadd}
          blockView={true}
          handleExportBtn={true}
          handleExport={handleInventoryIndentExport}
        />
      )}
      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Inventory Indent"
            />
            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div className={mainTable.grid5}>
                    <div>
                      <InputText
                        inputType="text"
                        title="Indent No."
                        name="IndentNo"
                        content={indentNumber}
                        classStar="text-red-500"
                        placeholder="Indent No"
                        maxLength={30}
                        disabled={true}
                        controlFunc={(e) => setIndentNumber(e.target.value)}
                      />
                      {indentNumberError && (
                        <span className="text-red-500">
                          {indentNumberError}
                        </span>
                      )}
                    </div>
                    <InputText
                      inputType="date"
                      title="Indent Date"
                      classStar="text-red-500"
                      name="indentDate"
                      content={indentDate}
                      controlFunc={(e) => setIndentDate(e.target.value)}
                      max={new Date().toISOString().split("T")[0]}
                    />
                    <InputText
                      inputType="text"
                      title="Branch"
                      name="branch"
                      disabled={true}
                      placeholder="Branch"
                      content={branch}
                      controlFunc={(e) => setBranch(e.target.value)}
                    />
                    {visibleSdp && (
                      <InputText
                        inputType="text"
                        title="S.D.P."
                        name="sdp"
                        content={sdp}
                        placeholder=""
                        disabled={true}
                        controlFunc={(e) => setSdp(e.target.value)}
                      />
                    )}
                    {!visibleSdp && (
                      <DropDown
                        title="S.D.P."
                        options={sdpDD}
                        placeholder="Select"
                        name="sdp"
                        selectedOption={sdp}
                        controlFunc={handleSdpDropdownChange}
                      />
                    )}
                    <AutoDropDown
                      title="Area"
                      options={bindAreaDD1}
                      disabled={bindAreaDD1.length === 0}
                      name="area"
                      placeholder="Select"
                      Class="custom-class"
                      selectedOption={bindAreaDD1.find((x) => x.value == area)}
                      controlFunc={(value) => {
                        setArea(value.value);
                      }}
                    />
                  </div>
                  <div className={mainTable.gridInventory3}>
                    <div>
                      <DropDown
                        title="Indent"
                        options={bindOrganizationStructure}
                        placeholder="Select"
                        classStar="text-red-500"
                        name="productReceivedFrom"
                        selectedOption={selectedReceivedFrom}
                        controlFunc={handleReceivedFromChange}
                        controlFuncBlur={(e) => {
                          const selectedValue = e.target.value;
                          setSelectedReceivedFrom(selectedValue);
                          // Validation check
                          if (selectedValue.length === 0) {
                            setSelectedReceivedFromError("Select Indent");
                          } else {
                            setSelectedReceivedFromError("");
                          }
                        }}
                      />
                      {selectedReceivedFromError && (
                        <div className="text-red-500">
                          {selectedReceivedFromError}
                        </div>
                      )}
                    </div>
                    {selectedReceivedFrom1 !== "1" &&
                      selectedReceivedFrom1 !== "7" && (
                        <AutoDropDown
                          title={
                            selectedReceivedFrom1 == "2"
                              ? "Branch/Project"
                              : selectedReceivedFrom1 == "3"
                                ? "Supplier"
                                : selectedReceivedFrom1 == "4"
                                  ? "S.D.P"
                                  : selectedReceivedFrom1 == "5"
                                    ? "Outreach Staff Name"
                                    : "Partner Organization"
                          }
                          options={getDataBasedOnReceivedFrom()}
                          name="branch"
                          placeholder="Select"
                          classStar="text-red-500"
                          selectedOption={indentFrom2}
                          // selectedOption={
                          //   indentFrom2
                          //     ? getDataBasedOnReceivedFrom(
                          //         selectedReceivedFrom1
                          //       )?.find(
                          //         (x) => String(x.value) === String(indentFrom2)
                          //       ) || null
                          //     : null
                          // }
                          controlFunc={(value, e) => {
                            setIndentFrom2(value, e?.name);
                          }}
                          controlFuncBlur={() => {
                            const errorMessage =
                              selectedReceivedFrom1 == "2"
                                ? "Select Indent Branch/Project"
                                : selectedReceivedFrom1 == "3"
                                  ? "Select Supplier"
                                  : selectedReceivedFrom1 == "4"
                                    ? "Select Indent S.D.P"
                                    : selectedReceivedFrom1 == "6"
                                      ? "Select Partner Organization"
                                      : "Select Indent Outreach Staff";
                            // setIndentFrom2Error(
                            //   indentFrom2 ? "" : errorMessage,
                            // );
                          }}
                          errorMessage={indentFrom2Error?.indentFrom2Error}
                          setError={setIndentFrom2Error}
                        />
                      )}
                    {selectedReceivedFrom1 == "4" && (
                      <AutoDropDown
                        title=" Area Name"
                        options={bindAreaDropDown}
                        name="areaName"
                        placeholder="Select"
                        selectedOption={indentAreaName}
                        // selectedOption={bindAreaDropDown.find(
                        //   (x) => x.value == indentAreaName
                        // )}
                        Class="custom-class"
                        classStar="text-red-500"
                        // disabled="false"
                        // tabIndex="1"
                        controlFunc={(value) => {
                          setIndentAreaName(value);
                        }}
                        controlFuncBlur={() => {
                          setIndentAreaNameError(
                            indentAreaName.value ? "" : "Select Area Name",
                          );
                        }}
                        errorMessage={indentAreaNameError?.indentAreaNameError}
                        setError={setIndentAreaNameError}
                      />
                    )}
                  </div>
                  {/* <div className={mainTable.grid3}> */}

                  <div className="hidden lg:block col-span-3">
                    <table className="w-full border border-gray-300 mt-6">
                      <thead>
                        <tr>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-36">
                            Commodities
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-36">
                            Category
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-36">
                            Name
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-8">
                            Qty.
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-20">
                            U.O.M.
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-16">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((row, index) => (
                          <tr key={index}>
                            <td className="border border-gray-300 p-2">
                              <AutoDropDown
                                options={bindCommodityType}
                                placeholder="Select"
                                name="Category"
                                Class="p-0"
                                selectedOption={bindCommodityType.find(
                                  (x) => x.value == row.indentCategoryType,
                                )} // Use the entire object
                                controlFunc={(e) => {
                                  row.indentCategory = "";
                                  row.indentName = "";
                                  handleInputChange(
                                    e,
                                    index,
                                    "indentCategoryType",
                                  );
                                }}
                              />
                            </td>
                            <td className="border border-gray-300 p-2">
                              <AutoDropDown
                                options={row.indentCategoryList || []}
                                placeholder="Select"
                                name="Category"
                                Class="p-0"
                                selectedOption={
                                  row.indentCategoryList && row.indentCategory
                                    ? row.indentCategoryList.find(
                                        (x) => x.value === row.indentCategory,
                                      )
                                    : null
                                }
                                controlFunc={(e) => {
                                  row.indentName = "";
                                  handleInputChange(e, index, "indentCategory");
                                }}
                              />
                            </td>
                            <td className="border border-gray-300 p-2">
                              <AutoDropDown
                                options={row.indentNameList || []}
                                name="name"
                                placeholder="Select"
                                selectedOption={
                                  row.indentNameList && row.indentName
                                    ? row.indentNameList.find(
                                        (x) => x.value === row.indentName,
                                      )
                                    : null
                                }
                                Class="p-0"
                                controlFunc={(e) => {
                                  handleInputChange(e, index, "indentName");
                                }}
                              />
                            </td>
                            <td className="border border-gray-300 p-2">
                              <InputText
                                type="text"
                                className={mainTable.input}
                                content={row.indentQuantity}
                                maxLength={7}
                                controlFunc={(e) => {
                                  if (/^[0-9]*$/.test(e.target.value)) {
                                    handleInputChange(
                                      e.target,
                                      index,
                                      "indentQuantity",
                                    );
                                  }
                                }}
                              />
                            </td>
                            <td className="border border-gray-300 p-2">
                              <InputText
                                type="text"
                                className={mainTable.input}
                                content={row.UOM}
                                disabled={true}
                                controlFunc={(e) => {
                                  handleInputChange(e.target, index, "UOM");
                                }}
                              />
                            </td>

                            <td className="border border-gray-300">
                              <div className="flex gap-4 align-baseline items-center justify-center">
                                <svg
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  className="w-6 h-6 text-black cursor-pointer"
                                  onClick={() => handleDeleteRow(index)}
                                >
                                  <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                                </svg>
                                <svg
                                  viewBox="0 0 1024 1024"
                                  fill="currentColor"
                                  onClick={handleAddRow}
                                  className="w-6 h-6 text-black cursor-pointer"
                                >
                                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                                </svg>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="hidden md:block">
                    {indentChildTableError && (
                      <div className="text-red-500">
                        {indentChildTableError}
                      </div>
                    )}
                  </div>

                  <div className={mainTable.tableMobile} role="table">
                    <div className="w-full md:overflow-y-auto lg:h-96 h-full">
                      {tableData.length > 0 &&
                        tableData.map((row, index) => (
                          <div scope="col" className={mainTable.mobileTable}>
                            {headerData.map((keyData) => (
                              <div
                                scope="cell"
                                className={mainTable.tableData}
                                role="cell"
                              >
                                {keyData.key === "Action" ? (
                                  <div className={mainTable.tableData}>
                                    <div className="md:block hidden">
                                      <button
                                        id="dropdownMenuIconButton"
                                        data-dropdown-toggle="dropdownDots"
                                        className="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none  focus:ring-gray-50 "
                                        type="button"
                                      >
                                        <svg
                                          className="w-6 h-6"
                                          aria-hidden="true"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                                        </svg>
                                      </button>
                                    </div>
                                    <div className="md:hidden flex justify-center">
                                      <input
                                        type="button"
                                        className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                        onClick={handleAddRow}
                                        value="Add"
                                      />
                                      <input
                                        type="button"
                                        className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                        onClick={() => handleDeleteRow(index)}
                                        value="Delete"
                                      />
                                    </div>
                                  </div>
                                ) : keyData.key === "indentCategoryType" ? (
                                  <div className=" border p-1">
                                    <div className="flex items-center w-full whitespace-nowrap font-bold">
                                      {keyData.title}
                                    </div>
                                    <AutoDropDown
                                      options={bindCommodityType}
                                      placeholder="Select"
                                      name="Category"
                                      Class="p-0"
                                      selectedOption={bindCommodityType.find(
                                        (x) =>
                                          x.value == row.indentCategoryType,
                                      )} // Use the entire object
                                      controlFunc={(e) => {
                                        row.indentCategory = "";
                                        row.indentName = "";
                                        handleInputChange(
                                          e,
                                          index,
                                          "indentCategoryType",
                                        );
                                      }}
                                    />
                                  </div>
                                ) : keyData.key === "indentCategory" ? (
                                  <div className=" border p-1">
                                    <div className="flex items-center w-full whitespace-nowrap font-bold">
                                      {keyData.title}
                                    </div>
                                    <AutoDropDown
                                      options={row.indentCategoryList || []}
                                      placeholder="Select"
                                      name="Category"
                                      Class="p-0"
                                      selectedOption={
                                        row.indentCategoryList &&
                                        row.indentCategory
                                          ? row.indentCategoryList.find(
                                              (x) =>
                                                x.value === row.indentCategory,
                                            )
                                          : null
                                      }
                                      controlFunc={(e) => {
                                        row.indentName = "";
                                        handleInputChange(
                                          e,
                                          index,
                                          "indentCategory",
                                        );
                                      }}
                                    />
                                  </div>
                                ) : keyData.key === "indentName" ? (
                                  <div className=" border p-1">
                                    <div className="flex items-center w-full whitespace-nowrap font-bold">
                                      {keyData.title}
                                    </div>
                                    <AutoDropDown
                                      options={row.indentNameList || []}
                                      name="name"
                                      placeholder="Select"
                                      selectedOption={
                                        row.indentNameList && row.indentName
                                          ? row.indentNameList.find(
                                              (x) => x.value === row.indentName,
                                            )
                                          : null
                                      }
                                      Class="p-0"
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e,
                                          index,
                                          "indentName",
                                        );
                                      }}
                                    />
                                  </div>
                                ) : keyData.key === "indentQuantity" ? (
                                  <div className=" border p-1">
                                    <div className="flex items-center w-full font-bold">
                                      {keyData.title}
                                    </div>
                                    <InputText
                                      type="text"
                                      className={mainTable.input}
                                      content={row.indentQuantity}
                                      maxLength={7}
                                      controlFunc={(e) => {
                                        if (/^[0-9]*$/.test(e.target.value)) {
                                          handleInputChange(
                                            e.target,
                                            index,
                                            "indentQuantity",
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                ) : keyData.key === "UOM" ? (
                                  <div className=" border p-1">
                                    <div className="flex items-center w-full font-bold">
                                      {keyData.title}
                                    </div>
                                    <InputText
                                      type="text"
                                      className={mainTable.input}
                                      content={row.UOM}
                                      disabled={true}
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e.target,
                                          index,
                                          "UOM",
                                        );
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div className="flex border p-1">
                                    <div className="flex basis-1/2 font-bold">
                                      {keyData.title}
                                    </div>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="md:hidden">
                    {indentChildTableError && (
                      <div className="text-red-500">
                        {indentChildTableError}
                      </div>
                    )}
                  </div>
                  <div className="lg:col-span-3 sm:col-span-1">
                    <TextArea
                      inputType="text"
                      title=" Description"
                      name="Description"
                      rows={4}
                      content={description}
                      maxLength={500}
                      placeholder="Description"
                      controlFunc={(e) => setDescription(e.target.value)}
                    />
                  </div>
                  {/* </div> */}
                </form>
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
                {submitVisibleButton && (
                  <div className="border p-2 flex flex-col items-center justify-center ">
                    <label className="flex gap-1  mb-2 text-sm font-medium text-neutral-700 ">
                      Indent No. :
                      <span className=" mb-2 text-sm font-bold text-neutral-700 ">
                        {indentNumber}
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={HandleUserDetails}
      >
        <div className=" flex flex-col gap-3">
          <PopUpScreenTitle
            title="Inventory Indent"
            setpopUpOpen={handleClose}
            viewDetails={viewDetails}
            deleteDetails={deleteButton}
            blockDetails={blockButton}
          />
          <Indent data={indentData} data2={currentData2} data3={currentData3} />
        </div>
        <PopUpButtons
          deleteDetails={deleteButton}
          blockDetails={blockButton}
          unBlockDetails={unBlockButton}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
}

export default InventoryIndent;
